module.exports = __webpack_public_path__ + "static/media/Quest-Wizards_and_Wurms.371b5ead.png";